//
//
//
//
//
//
//
//


export default {
	name: "hub-data-fragment",

	props: {
		as: {default: "div", type: String},
		initialParams: {default: () => ({}), type: Object},
		url: {default: null, required: true, type: String | null}
	},

	data()
	{
		return {
			data: null,
			isLoading: false,
			params: this.initialParams
		};
	},

	mounted()
	{
		this.load();
	},

	methods: {

		load()
		{
			this.reset();

			if (this.url === null)
				return;

			this.isLoading = true;
			const params = new URLSearchParams(this.params);

			Latte.api.request(`${this.url}?${params}`)
				.then(r => r.json())
				.then(r => this.onReceivedData(r))
				.catch(err => Latte.core.handleError(err));
		},

		reset()
		{
			this.data = null;
		},

		setParam(name, value)
		{
			this.$set(this.params, name, value);
		},

		onReceivedData(response)
		{
			this.data = response.data;
			this.isLoading = false;
		}

	},

	watch: {

		params: {
			deep: true,
			handler()
			{
				this.load();
			}
		},

		url()
		{
			this.load();
		}

	}

}

